import { ActionIcon, Badge, Button, Grid, Group, Menu, Modal, Paper, Stack, Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import Table from '../components/table';
import { useLanguage } from '../contexts/language.context';
import { CREATE_CUSTOMER, UPDATE_CUSTOMER } from '../services/customers';
import { GET_ALL_CUSTOMERS } from '../services/customers';
import { docsTypes, getExtenseDatetime, parseKeyword, phoneCountryCodes } from '../utility/util';
import { useMediaQuery } from '@mantine/hooks';

export default function CustomersPage() {
    const [customers, setCustomers] = useState<any[]>([]);
    const [customerModal, setCustomerModal] = useState<any>(null);
    const [filters, setFilters] = useState<any>({})
    const [loadingSaveCustomer, setLoadingSaveCustomer] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState<boolean>(false);

    const isMobile = useMediaQuery('(max-width: 900px)');
    const { str } = useLanguage();

    const saveCustomerStatus = async (customerId: string, status: number) => {
        let params = { status };
        const prev = customers;
        setCustomers(cs => cs.map(c => c._id === customerId ? { ...c, status } : c))
        UPDATE_CUSTOMER(customerId, params)
            .then(res => { })
            .catch(err => {
                setCustomers(prev);
                showNotification({ message: err.message, color: "red" })
            })
    }

    const loadData = async () => {
        try {
            setLoadingData(true);
            setCustomers(await GET_ALL_CUSTOMERS());
        } catch (err: any) {
            showNotification({ message: err.message, color: "red" })
        } finally {
            setLoadingData(false);
        }
    }

    const saveCustomer = () => {
        const customer = customerModal;
        if (!customer._id) {
            setLoadingSaveCustomer(true);
            CREATE_CUSTOMER(customer)
                .then(res => {
                    loadData();
                    setCustomerModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveCustomer(false); })
        } else {
            setLoadingSaveCustomer(true);
            let params = { ...customer };
            delete params._id;
            UPDATE_CUSTOMER(customer._id, params)
                .then(res => {
                    loadData();
                    setCustomerModal(null);
                })
                .catch(err => { showNotification({ message: err.message, color: "red" }) })
                .finally(() => { setLoadingSaveCustomer(false); })
        }
    }

    useEffect(() => {
        loadData();
    }, [])

    return <>
        <Grid align='flex-end'>
            <Grid.Col span={{ md: 3 }}>
                <InputField
                    name="search"
                    placeholder="Buscar"
                    value={filters.search}
                    onChange={(dt: any) => setFilters((f: any) => ({ ...f, ...dt }))}
                />
            </Grid.Col>
            <Grid.Col span={{ md: 3 }}>
            </Grid.Col>
            <Grid.Col span={{ md: 4 }}>
            </Grid.Col>
            <Grid.Col span={{ md: 2 }}>
                <Button fullWidth loading={loadingData} onClick={() => setCustomerModal({})} leftSection={<FaPlus />}>Cadastrar</Button>
            </Grid.Col>
            <Grid.Col span={{ md: 12 }}>
                <Table
                    columns={[
                        {
                            title: "Status", key: "status", render: (item) => (
                                <Menu>
                                    <Menu.Target>
                                        {
                                            ({
                                                "1": <Badge color="yellow">pendente</Badge>,
                                                "2": <Badge color="green">aprovado</Badge>,
                                            }[item.status as string])
                                        }
                                    </Menu.Target>
                                    <Menu.Dropdown>
                                        {item.status === 1 && <Menu.Item
                                            onClick={() => saveCustomerStatus(item._id, 2)}
                                        >Aprovar</Menu.Item>}
                                        {item.status === 2 && <Menu.Item
                                            onClick={() => saveCustomerStatus(item._id, 1)}
                                        >Pendência</Menu.Item>}
                                    </Menu.Dropdown>
                                </Menu>
                            )
                        },
                        { title: "Nome", key: "name" },
                        { title: "CPF/CNPJ", key: "register_number" },
                        { title: "Phone", key: "name", render: item => `+${item.country_code}${item.phone}` },
                        { title: "E-mail", key: "email" },
                        { title: "Documentos", key: "docs", render: item => (item?.docs ?? []).map((doc: any) => (
                            doc.file && <Button onClick={() => window.open(doc.file, "_blank")} size="xs">{docsTypes.find(dc => dc.value === doc.type)?.label}</Button>
                        )) },
                    ]}
                    data={customers.filter(c => (
                        [
                            parseKeyword(c.name ?? ""),
                            parseKeyword(c.register_number ?? ""),
                            parseKeyword(c.phone ?? ""),
                            parseKeyword(c.email ?? ""),
                        ].join(",").includes(parseKeyword(filters.search))
                    ))}
                    actions={[
                        { title: "Editar", onClick: ({ item }) => setCustomerModal(item) }
                    ]}
                />
            </Grid.Col>
        </Grid>

        <Modal
            opened={!!customerModal}
            onClose={() => setCustomerModal(null)}
            size="lg"
        >
            <Stack>
                <InputField
                    name="name"
                    value={customerModal?.name}
                    title="Nome"
                    onChange={({ name }: any) => setCustomerModal((pv: any) => ({ ...pv, name }))}
                />
                <Group style={isMobile ? { display: 'block' } : {}}>
                    <div style={isMobile ? {} : { flex: 0.3 }}>
                        <InputField
                            title={"País"}
                            name="country_code"
                            autoComplete="tel-country-code"
                            clearable={false}
                            fieldType={InputFieldTypes.SELECT}
                            value={customerModal?.country_code ?? "55"}
                            onChange={({ country_code }: any) => setCustomerModal((pv: any) => ({ ...pv, country_code }))}
                            options={phoneCountryCodes}
                        />
                    </div>
                    <div style={isMobile ? {} : { flex: 0.7 }}>
                        <InputField
                            title="Celular"
                            name="phone"
                            value={customerModal?.phone}
                            onChange={({ phone }: any) => setCustomerModal((pv: any) => ({ ...pv, phone }))}
                        />
                    </div>
                </Group>
                <InputField
                    name="email"
                    value={customerModal?.email}
                    title="E-mail"
                    onChange={({ email }: any) => setCustomerModal((pv: any) => ({ ...pv, email }))}
                />
                <InputField
                    name="register_number"
                    value={customerModal?.register_number}
                    title="CPF/CNPJ"
                    onChange={({ register_number }: any) => setCustomerModal((pv: any) => ({ ...pv, register_number }))}
                />
                <Group justify='space-between'>
                    <Text>Documentos</Text>
                    <ActionIcon onClick={() => { setCustomerModal((mm: any) => ({ ...mm, docs: [...(mm.docs ?? []), {}] })) }}><FaPlus /></ActionIcon>
                </Group>
                {
                    (customerModal?.docs ?? []).map((c: any, i: number) => <Paper style={{ backgroundColor: '#EFEFEF' }} p="md">
                        <InputField
                            name="type"
                            value={c.type}
                            clearable={false}
                            onChange={({ type }: any) => setCustomerModal((pv: any) => ({ ...pv, docs: customerModal.docs.map((c2: any, j: number) => i === j ? { ...c2, type } : c2) }))}
                            fieldType={InputFieldTypes.SELECT}
                            options={docsTypes.filter(cc => (cc.value === c?.type) || !(customerModal?.docs ?? []).some((cc2: any) => cc2.type === cc.value))}
                        />
                        <InputField
                            name="file"
                            value={c.file}
                            clearable={false}
                            onChange={({ file }: any) => setCustomerModal((pv: any) => ({ ...pv, docs: customerModal.docs.map((c2: any, j: number) => i === j ? { ...c2, file } : c2) }))}
                            fieldType={InputFieldTypes.FILE}
                        />
                    </Paper>)
                }

                <Group justify='flex-end'>
                    <Button
                        onClick={saveCustomer}
                        loading={loadingSaveCustomer}
                        disabled={!customerModal?.name}
                    >Salvar</Button>
                </Group>
            </Stack>
        </Modal>
    </>
}
